/* GLOBAL POLE INVENTORY (2026-10-24) — the frames' monthly stock movement. Codes (HINC, HUSA, SAP, ZCOR0120, KRW, SGD)
   stay as they are in every language. */
const en = {
  title: 'Pole Inventory Close',
  tab_position: "Current position",
  allEntities: "All entities",
  expandAll: "Expand all",
  collapseAll: "Collapse all",
  posReading: "Reading SAP and NetSuite — about 20 seconds…",
  posRefresh: "Read again",
  posWindow: "From the end of {{base}} · received and sold {{from}} to {{to}} · sales through {{s}}",
  posStock: "Stock",
  posOpenPo: "Open purchase orders (not yet received)",
  posCover: "Cover",
  posEnd: "End {{m}}",
  posReceived: "+ Received",
  posReceivedHint: "Goods received into the entity's own stock since — goods in transit are not counted. HINC: goods receipts at plant 1100.",
  posToGroup: "− To other entities",
  posToGroupHint: "HINC only: goods billed on to HUSA, HEMA and HPAC (sales group 170) since — they leave HINC's stock but are not customer sales.",
  posSold: "− Sold",
  posOther: "± Other",
  posOtherHint: "What received and sold do not explain: adjustments, sets sold as one item, transfers. Today's stock is read, not worked out.",
  posNow: "= Stock today",
  posOverdue: "Overdue",
  posLater: "Later",
  posNoDate: "No date",
  posAvg: "Avg sales / month",
  posAvgHint: "The average month of the three up to {{m}}",
  posMos: "Months of stock",
  posMosHint: "Stock today ÷ average monthly sales. Under 2 is marked.",
  posMosPo: "… incl. open PO",
  posFamilies: "{{n}} families",
  posGroup: "All entities",
  posFoot: "HINC's open POs leave out the factory orders it places for HUSA, HEMA and HPAC goods ({{n}} pcs): those entities' own POs to Helinox Inc already count them. Furniture and shade frames only — tents, accessories and bags are not in the families.",
  posUnmapped: "Sales of these frame models are in no family yet: {{list}}",
  sub: 'The furniture frames\' stock movement month by month — Beginning, In, Out, Ending, in pieces and KRW — for HINC (finished goods and frames only, from SAP ZCOR0120) and HUSA, HEMA, HPAC (NetSuite report 808, SGD at NetSuite\'s own rates). A month is closed around the 21st of the next and its figures are then kept as they were.',
  from: 'From', to: 'To', refresh: 'Read again', export: 'Export (Excel)', loading: 'Loading…',
  tab_summary: 'Summary', tab_month: 'Month by family', tab_sales: 'Monthly sales', tab_loads: 'Loads & close', tab_map: 'Mapping', tab_buyers: 'Direct-sale buyers',
  tEndQty: 'Ending stock · {{m}}', tEndValue: 'Ending value · {{m}}', vsPrev: '{{d}} on the month before', pcs: 'pcs', krwMil: 'KRW million',
  tFinished: 'Finished goods', tFinishedSub: 'HINC, HUSA, HEMA, HPAC', tPole: 'Frames only (HINC)', tPoleSub: 'SAP raw material (ROH)',
  entity: 'Entity', line: 'Line', qty: 'Qty', krwM: 'KRW M', closed: 'closed',
  e_HINC: 'HINC (Complete)', e_HUSA: 'HUSA', e_HEMA: 'HEMA', e_HPAC: 'HPAC', e_HINC_POLE: 'HINC Only Pole',
  lBegin: 'Beginning Inv', lIn: 'Inventory Received', lOut: 'Inventory Issued', lEnd: 'Ending Inv',
  lBeginNs: 'Beginning Inv', lInNs: 'Stock In', lOutNs: 'Stock Out', lEndNs: 'Ending Inv',
  lFx: 'FX difference', lGap: 'Value gap', lRate: 'KRW per SGD (month-end · average)',
  fxHint: 'NetSuite values are SGD: Beginning at the previous month-end rate, Ending at this month-end\'s, In and Out at the month\'s average. What that leaves is this line.',
  gapHint: 'Received and Issued leave out what was billed to sales group 170 (internal), each at its own unit cost, so Beginning + In − Out does not quite reach Ending. This line is the difference.',
  sumFoot: 'Rates are NetSuite\'s own daily rates (SGD base), read into the portal. HINC is SAP ZCOR0120 as uploaded; materials whose description holds "(WRT)" are left out, as in the working file.',
  month: 'Month', code: 'Code', family: 'Family', total: 'Total', totalQty: 'Total qty', totalKrw: 'Total KRW (million)', nothingMonth: 'Nothing is loaded for this month.',
  s_begin: 'Beginning', s_in: 'In', s_out: 'Out', s_end: 'Ending',
  year: 'Year', product: 'Product', salesThrough: 'Sales through {{d}}', portalSays: 'The portal works out {{n}} from today\'s sales data',
  salesFoot: 'A month the working file typed (shaded) keeps its typed figure; later months are worked out from the Sales Report\'s own table — frame models and categories as the working file\'s filter, internal-company sales left out, HINC split into Montbell + A&F, the sub-channel "Others" (ETC) and the rest. Where today\'s data gives another figure it shows struck through under the typed one.',
  loadsHint: 'Each month needs ZCOR0120 (SAP) and the NetSuite stock ledger (report 808) uploaded, and the internal billing (sales group 170) read from SAP. Loading again replaces the load before (kept). Close freezes the month\'s figures; Reopen lets it be loaded again.',
  otherMonth: 'Another month', srcSap: 'SAP ZCOR0120', srcNs: 'NetSuite ledger (808)', srcInternal: 'Internal billing (group 170)', status: 'Status', action: 'Action',
  rows: 'rows', notLoaded: 'Not loaded', lastFailed: 'Last load failed', running: 'Running…', upload: 'Upload file', readSap: 'Read from SAP',
  closedBy: 'Closed by {{by}} · {{when}}', open: 'Open', reopen: 'Reopen', close: 'Close the month', closeNeeds: 'Load ZCOR0120 or the NetSuite ledger first.',
  rowsRead: '{{n}} rows read', reopened: '{{m}} is open again.', closedOk: '{{m}} closed — {{n}} figures kept.',
  mapCounts: '{{fam}} families · {{sap}} SAP materials · {{ns}} NetSuite items mapped', mapHint: 'What this month\'s loads hold with stock or movement that maps to no family. A material or item put in a family here counts from the next time the figures are worked out (a closed month keeps its figures).',
  unSap: 'SAP materials with no family ({{n}})', unNs: 'NetSuite items with no family ({{n}})', material: 'Material', description: 'Description', type: 'Type', endQty: 'Ending qty', parent: 'Item (parent)', lines: 'Lines',
  sheet1: 'Sheet 1 · by entity', sheet2: 'Sheet 2 · DT split out', typedThrough: 'typed history through {{m}}',
  salesFoot2: 'Sheet 2 takes each entity\'s sales to a buyer on the direct-sale (DT) list out of the entity\'s row and into "<entity> DT" — the entity that made the sale is the one counted. The matched customers are listed on the Direct-sale buyers tab.',
  why_same: 'same name in the KS map', why_mapped: 'holds the mapped name "{{term}}"', why_family: 'holds the family name "{{term}}"',
  onlyLikely: 'Only likely frames', unSapLikely: 'SAP materials that look like a frame ({{n}} of {{total}})', unNsLikely: 'NetSuite items that look like a frame ({{n}} of {{total}})',
  suggested: 'Suggested', acceptN: 'Accept {{n}} suggestions', acceptAsk: 'Save {{n}} items to the family in their box?', acceptYes: 'Save', cancel: 'Cancel',
  acceptedN: '{{n}} items saved to their families.', noneLikely: 'Nothing here looks like a frame — untick "Only likely frames" to see the rest.',
  matchesTitle: 'Sales customers matched to a DT buyer ({{y}})', matchesHint: 'Which sales customers Sheet 2 counted as each buyer this year — a name that only starts like a buyer\'s shows here.',
  salesCustomer: 'Sales customer', noMatches: 'No sale matched a DT buyer this year.',
  notFrame: 'Not a frame', save: 'Save', mapSaved: '{{key}} saved.', allMapped: 'Everything with stock maps to a family.',
  buyersHint: 'The buyers HINC sells to directly, as the frame sales file lists them. Shown only — changes come from Max.',
  search: 'Search', nOf: '{{n}} of {{total}}', buyer: 'Buyer', cBefore: 'Before 2020', c2020: '2020–2025', c2026: 'From 2026', country: 'Country', pricing: 'Pricing',
};
const ko = {
  title: '폴 재고 월마감',
  tab_position: "현재 현황",
  allEntities: "전체 법인",
  expandAll: "모두 펼치기",
  collapseAll: "모두 접기",
  posReading: "SAP와 NetSuite를 읽는 중 — 약 20초…",
  posRefresh: "다시 읽기",
  posWindow: "{{base}} 말 기준 · 입고·판매 {{from}} ~ {{to}} · 판매 데이터 {{s}}까지",
  posStock: "재고",
  posOpenPo: "미입고 발주 (PO)",
  posCover: "재고 일수",
  posEnd: "{{m}} 말",
  posReceived: "+ 입고",
  posReceivedHint: "이후 법인 자체 재고로 입고된 수량 — 운송 중 물량은 제외. HINC: 1100 플랜트 입고.",
  posToGroup: "− 타 법인 출고",
  posToGroupHint: "HINC만 해당: 이후 HUSA·HEMA·HPAC로 청구된 물량(판매그룹 170) — HINC 재고에서 나가지만 고객 판매는 아님.",
  posSold: "− 판매",
  posOther: "± 기타",
  posOtherHint: "입고와 판매로 설명되지 않는 차이: 조정, 세트 판매, 이동 등. 현재 재고는 계산값이 아니라 실제 조회값.",
  posNow: "= 현재 재고",
  posOverdue: "지연",
  posLater: "이후",
  posNoDate: "날짜 없음",
  posAvg: "월평균 판매",
  posAvgHint: "{{m}}까지 3개월 평균",
  posMos: "재고 개월수",
  posMosHint: "현재 재고 ÷ 월평균 판매. 2 미만은 표시.",
  posMosPo: "… 미입고 PO 포함",
  posFamilies: "{{n}}개 패밀리",
  posGroup: "전체 법인",
  posFoot: "HINC의 미입고 PO에서 HUSA·HEMA·HPAC용 공장 발주({{n}}개)는 제외 — 해당 법인의 Helinox Inc 앞 PO에 이미 포함. 퍼니처·쉐이드 프레임만 해당하며 텐트·액세서리·가방은 포함되지 않음.",
  posUnmapped: "다음 프레임 모델의 판매는 아직 패밀리에 없음: {{list}}",
  sub: '가구 프레임의 월별 재고 수불 — 기초, 입고, 출고, 기말 (수량, KRW) — HINC(완제품 및 프레임 단품, SAP ZCOR0120)와 HUSA, HEMA, HPAC(NetSuite 리포트 808, NetSuite 환율로 SGD 환산). 다음 달 21일경 마감하며 이후 수치는 그대로 보관됩니다.',
  from: '시작', to: '종료', refresh: '다시 읽기', export: '내보내기 (Excel)', loading: '불러오는 중…',
  tab_summary: '요약', tab_month: '패밀리별 월', tab_sales: '월별 판매', tab_loads: '적재 및 마감', tab_map: '매핑', tab_buyers: '직판 바이어',
  tEndQty: '기말 재고 · {{m}}', tEndValue: '기말 금액 · {{m}}', vsPrev: '전월 대비 {{d}}', pcs: '개', krwMil: '백만 KRW',
  tFinished: '완제품', tFinishedSub: 'HINC, HUSA, HEMA, HPAC', tPole: '프레임 단품 (HINC)', tPoleSub: 'SAP 원자재 (ROH)',
  entity: '법인', line: '항목', qty: '수량', krwM: 'KRW 백만', closed: '마감',
  e_HINC: 'HINC (완제품)', e_HUSA: 'HUSA', e_HEMA: 'HEMA', e_HPAC: 'HPAC', e_HINC_POLE: 'HINC 프레임 단품',
  lBegin: '기초 재고', lIn: '입고', lOut: '출고', lEnd: '기말 재고',
  lBeginNs: '기초 재고', lInNs: '입고', lOutNs: '출고', lEndNs: '기말 재고',
  lFx: '환율 차이', lGap: '금액 차이', lRate: 'SGD당 KRW (월말 · 평균)',
  fxHint: 'NetSuite 금액은 SGD입니다. 기초는 전월말 환율, 기말은 당월말 환율, 입고와 출고는 월평균 환율로 환산하며 그 차이가 이 줄입니다.',
  gapHint: '입고와 출고에서 영업그룹 170(내부) 청구분을 각각의 단가로 제외하므로 기초 + 입고 − 출고가 기말과 정확히 맞지 않습니다. 이 줄이 그 차이입니다.',
  sumFoot: '환율은 NetSuite의 일별 환율(SGD 기준)을 포털로 읽어 온 것입니다. HINC는 업로드한 SAP ZCOR0120이며, 작업 파일과 같이 설명에 "(WRT)"가 있는 자재는 제외합니다.',
  month: '월', code: '코드', family: '패밀리', total: '합계', totalQty: '합계 수량', totalKrw: '합계 KRW (백만)', nothingMonth: '이 달에 적재된 데이터가 없습니다.',
  s_begin: '기초', s_in: '입고', s_out: '출고', s_end: '기말',
  year: '연도', product: '제품', salesThrough: '{{d}}까지의 판매', portalSays: '현재 판매 데이터로 포털이 계산한 값은 {{n}}',
  salesFoot: '작업 파일에 입력된 월(음영)은 입력값을 그대로 쓰고, 이후 월은 세일즈 리포트 테이블에서 계산합니다 — 작업 파일 필터와 같은 프레임 모델과 카테고리, 내부 법인 판매 제외, HINC는 Montbell + A&F, 서브채널 "Others"(ETC), 그 외로 구분. 현재 데이터로 다른 값이 나오면 입력값 아래에 취소선으로 표시합니다.',
  loadsHint: '매월 ZCOR0120(SAP)과 NetSuite 재고 원장(리포트 808)을 업로드하고, 내부 청구(영업그룹 170)는 SAP에서 읽습니다. 다시 적재하면 이전 적재를 대체합니다(보관됨). 마감하면 그 달의 수치가 고정되고, 재개하면 다시 적재할 수 있습니다.',
  otherMonth: '다른 월', srcSap: 'SAP ZCOR0120', srcNs: 'NetSuite 원장 (808)', srcInternal: '내부 청구 (그룹 170)', status: '상태', action: '작업',
  rows: '행', notLoaded: '적재 안 됨', lastFailed: '마지막 적재 실패', running: '실행 중…', upload: '파일 업로드', readSap: 'SAP에서 읽기',
  closedBy: '{{by}} 마감 · {{when}}', open: '진행 중', reopen: '재개', close: '월 마감', closeNeeds: 'ZCOR0120 또는 NetSuite 원장을 먼저 적재하세요.',
  rowsRead: '{{n}}행 읽음', reopened: '{{m}}을(를) 다시 열었습니다.', closedOk: '{{m}} 마감 — {{n}}개 수치 보관.',
  mapCounts: '패밀리 {{fam}}개 · SAP 자재 {{sap}}개 · NetSuite 품목 {{ns}}개 매핑', mapHint: '이번 달 적재분 중 재고나 수불이 있는데 패밀리에 매핑되지 않은 것입니다. 여기서 패밀리에 넣으면 다음 계산부터 반영됩니다(마감된 달은 수치 유지).',
  unSap: '패밀리 없는 SAP 자재 ({{n}})', unNs: '패밀리 없는 NetSuite 품목 ({{n}})', material: '자재', description: '설명', type: '유형', endQty: '기말 수량', parent: '품목 (상위)', lines: '행 수',
  sheet1: '시트 1 · 법인별', sheet2: '시트 2 · DT 분리', typedThrough: '{{m}}까지 입력값 사용',
  salesFoot2: '시트 2는 각 법인이 직판(DT) 목록의 바이어에게 판매한 수량을 해당 법인 행에서 빼서 "<법인> DT" 행에 넣습니다 — 판매한 법인 기준입니다. 매칭된 고객은 직판 바이어 탭에 있습니다.',
  why_same: 'KS 매핑에 같은 이름', why_mapped: '매핑된 이름 "{{term}}" 포함', why_family: '패밀리 이름 "{{term}}" 포함',
  onlyLikely: '프레임으로 보이는 것만', unSapLikely: '프레임으로 보이는 SAP 자재 ({{total}}개 중 {{n}}개)', unNsLikely: '프레임으로 보이는 NetSuite 품목 ({{total}}개 중 {{n}}개)',
  suggested: '제안', acceptN: '제안 {{n}}개 적용', acceptAsk: '{{n}}개 항목을 선택된 패밀리로 저장할까요?', acceptYes: '저장', cancel: '취소',
  acceptedN: '{{n}}개 항목을 패밀리에 저장했습니다.', noneLikely: '프레임으로 보이는 항목이 없습니다 — "프레임으로 보이는 것만"을 해제하면 나머지가 보입니다.',
  matchesTitle: 'DT 바이어로 매칭된 판매 고객 ({{y}})', matchesHint: '올해 시트 2가 각 바이어로 집계한 판매 고객입니다 — 이름이 바이어와 앞부분만 같은 경우도 여기서 보입니다.',
  salesCustomer: '판매 고객', noMatches: '올해 DT 바이어와 매칭된 판매가 없습니다.',
  notFrame: '프레임 아님', save: '저장', mapSaved: '{{key}} 저장됨.', allMapped: '재고가 있는 모든 항목이 패밀리에 매핑되어 있습니다.',
  buyersHint: 'HINC가 직접 판매하는 바이어 (프레임 판매 파일 기준). 보기 전용 — 변경은 Max가 알려 줍니다.',
  search: '검색', nOf: '{{total}}개 중 {{n}}개', buyer: '바이어', cBefore: '2020년 이전', c2020: '2020–2025', c2026: '2026년부터', country: '국가', pricing: '가격 정책',
};
const vi = {
  title: 'Chốt tồn kho khung',
  tab_position: "Tình hình hiện tại",
  allEntities: "Tất cả entity",
  expandAll: "Mở hết",
  collapseAll: "Thu gọn hết",
  posReading: "Đang đọc SAP và NetSuite — khoảng 20 giây…",
  posRefresh: "Đọc lại",
  posWindow: "Từ cuối {{base}} · nhập và bán {{from}} đến {{to}} · số bán đến {{s}}",
  posStock: "Tồn kho",
  posOpenPo: "PO đang mở (chưa nhập kho)",
  posCover: "Số tháng tồn",
  posEnd: "Cuối {{m}}",
  posReceived: "+ Đã nhập",
  posReceivedHint: "Hàng đã vào kho của entity từ đó đến nay — hàng đang trên đường không tính. HINC: nhập kho plant 1100.",
  posToGroup: "− Chuyển entity khác",
  posToGroupHint: "Chỉ HINC: hàng xuất hóa đơn cho HUSA, HEMA, HPAC (sales group 170) từ đó đến nay — ra khỏi kho HINC nhưng không phải bán cho khách.",
  posSold: "− Đã bán",
  posOther: "± Khác",
  posOtherHint: "Phần nhập và bán không giải thích được: điều chỉnh, bán theo bộ, chuyển kho. Tồn hôm nay là số đọc thật, không phải số tính ra.",
  posNow: "= Tồn hôm nay",
  posOverdue: "Quá hạn",
  posLater: "Sau đó",
  posNoDate: "Không ngày",
  posAvg: "Bán TB / tháng",
  posAvgHint: "Trung bình 3 tháng đến {{m}}",
  posMos: "Số tháng tồn",
  posMosHint: "Tồn hôm nay ÷ bán trung bình tháng. Dưới 2 được tô.",
  posMosPo: "… gồm PO đang mở",
  posFamilies: "{{n}} dòng khung",
  posGroup: "Tất cả entity",
  posFoot: "PO đang mở của HINC không tính các đơn nhà máy đặt cho hàng HUSA, HEMA, HPAC ({{n}} cái): PO của các entity đó với Helinox Inc đã tính rồi. Chỉ khung furniture và shade — lều, phụ kiện, túi không nằm trong các dòng khung.",
  posUnmapped: "Số bán của các frame model này chưa thuộc dòng khung nào: {{list}}",
  sub: 'Xuất nhập tồn khung nội thất theo tháng — Đầu kỳ, Nhập, Xuất, Cuối kỳ, theo số lượng và KRW — cho HINC (thành phẩm và khung rời, từ SAP ZCOR0120) và HUSA, HEMA, HPAC (báo cáo NetSuite 808, SGD theo tỷ giá của NetSuite). Mỗi tháng được chốt khoảng ngày 21 tháng sau và số liệu khi đó được giữ nguyên.',
  from: 'Từ', to: 'Đến', refresh: 'Đọc lại', export: 'Xuất Excel', loading: 'Đang tải…',
  tab_summary: 'Tổng hợp', tab_month: 'Tháng theo dòng khung', tab_sales: 'Bán hàng theo tháng', tab_loads: 'Nạp dữ liệu & chốt', tab_map: 'Ánh xạ', tab_buyers: 'Khách mua trực tiếp',
  tEndQty: 'Tồn cuối kỳ · {{m}}', tEndValue: 'Giá trị cuối kỳ · {{m}}', vsPrev: '{{d}} so với tháng trước', pcs: 'cái', krwMil: 'triệu KRW',
  tFinished: 'Thành phẩm', tFinishedSub: 'HINC, HUSA, HEMA, HPAC', tPole: 'Khung rời (HINC)', tPoleSub: 'Nguyên vật liệu SAP (ROH)',
  entity: 'Pháp nhân', line: 'Dòng', qty: 'SL', krwM: 'Triệu KRW', closed: 'đã chốt',
  e_HINC: 'HINC (thành phẩm)', e_HUSA: 'HUSA', e_HEMA: 'HEMA', e_HPAC: 'HPAC', e_HINC_POLE: 'HINC chỉ khung',
  lBegin: 'Tồn đầu kỳ', lIn: 'Nhập kho', lOut: 'Xuất kho', lEnd: 'Tồn cuối kỳ',
  lBeginNs: 'Tồn đầu kỳ', lInNs: 'Nhập', lOutNs: 'Xuất', lEndNs: 'Tồn cuối kỳ',
  lFx: 'Chênh lệch tỷ giá', lGap: 'Chênh lệch giá trị', lRate: 'KRW mỗi SGD (cuối tháng · bình quân)',
  fxHint: 'Giá trị NetSuite là SGD: đầu kỳ theo tỷ giá cuối tháng trước, cuối kỳ theo tỷ giá cuối tháng này, nhập và xuất theo tỷ giá bình quân tháng. Phần còn lại là dòng này.',
  gapHint: 'Nhập và xuất đã trừ phần xuất hóa đơn cho nhóm bán hàng 170 (nội bộ), mỗi bên theo đơn giá riêng, nên Đầu kỳ + Nhập − Xuất không khớp hẳn Cuối kỳ. Dòng này là phần chênh.',
  sumFoot: 'Tỷ giá là tỷ giá hằng ngày của NetSuite (gốc SGD) đọc vào portal. HINC là SAP ZCOR0120 đã tải lên; vật tư có "(WRT)" trong mô tả được loại ra như trong file làm việc.',
  month: 'Tháng', code: 'Mã', family: 'Dòng khung', total: 'Tổng', totalQty: 'Tổng SL', totalKrw: 'Tổng KRW (triệu)', nothingMonth: 'Tháng này chưa nạp dữ liệu.',
  s_begin: 'Đầu kỳ', s_in: 'Nhập', s_out: 'Xuất', s_end: 'Cuối kỳ',
  year: 'Năm', product: 'Sản phẩm', salesThrough: 'Doanh số đến {{d}}', portalSays: 'Portal tính từ dữ liệu bán hàng hiện tại ra {{n}}',
  salesFoot: 'Tháng nào file làm việc đã ghi (tô nền) thì giữ số đã ghi; các tháng sau tính từ bảng của Sales Report — model khung và danh mục theo bộ lọc của file làm việc, bỏ doanh số nội bộ, HINC tách thành Montbell + A&F, kênh con "Others" (ETC) và phần còn lại. Nếu dữ liệu hiện tại ra số khác thì hiện gạch ngang dưới số đã ghi.',
  loadsHint: 'Mỗi tháng cần tải lên ZCOR0120 (SAP) và sổ kho NetSuite (báo cáo 808), và đọc hóa đơn nội bộ (nhóm bán hàng 170) từ SAP. Nạp lại sẽ thay lần nạp trước (vẫn giữ). Chốt thì cố định số liệu tháng; Mở lại thì được nạp lại.',
  otherMonth: 'Tháng khác', srcSap: 'SAP ZCOR0120', srcNs: 'Sổ kho NetSuite (808)', srcInternal: 'Hóa đơn nội bộ (nhóm 170)', status: 'Trạng thái', action: 'Thao tác',
  rows: 'dòng', notLoaded: 'Chưa nạp', lastFailed: 'Lần nạp gần nhất lỗi', running: 'Đang chạy…', upload: 'Tải file lên', readSap: 'Đọc từ SAP',
  closedBy: 'Chốt bởi {{by}} · {{when}}', open: 'Đang mở', reopen: 'Mở lại', close: 'Chốt tháng', closeNeeds: 'Hãy nạp ZCOR0120 hoặc sổ kho NetSuite trước.',
  rowsRead: 'Đã đọc {{n}} dòng', reopened: 'Đã mở lại {{m}}.', closedOk: 'Đã chốt {{m}} — giữ {{n}} số liệu.',
  mapCounts: '{{fam}} dòng khung · {{sap}} vật tư SAP · {{ns}} mặt hàng NetSuite đã ánh xạ', mapHint: 'Những gì dữ liệu tháng này có tồn hoặc phát sinh nhưng không thuộc dòng khung nào. Gán vào dòng khung ở đây thì được tính từ lần tính tiếp theo (tháng đã chốt giữ nguyên số).',
  unSap: 'Vật tư SAP chưa có dòng khung ({{n}})', unNs: 'Mặt hàng NetSuite chưa có dòng khung ({{n}})', material: 'Vật tư', description: 'Mô tả', type: 'Loại', endQty: 'SL cuối kỳ', parent: 'Mặt hàng (cha)', lines: 'Số dòng',
  sheet1: 'Sheet 1 · theo entity', sheet2: 'Sheet 2 · tách DT', typedThrough: 'giữ số đã ghi đến {{m}}',
  salesFoot2: 'Sheet 2 lấy phần mỗi entity bán cho khách nằm trong danh sách bán trực tiếp (DT) ra khỏi dòng của entity đó và đưa vào dòng "<entity> DT" — tính cho entity đã bán. Khách được ghép nằm ở tab Khách bán trực tiếp.',
  why_same: 'trùng tên trong bảng KS', why_mapped: 'chứa tên đã ánh xạ "{{term}}"', why_family: 'chứa tên dòng khung "{{term}}"',
  onlyLikely: 'Chỉ những mã nghi là khung', unSapLikely: 'Vật tư SAP nghi là khung ({{n}} / {{total}})', unNsLikely: 'Mặt hàng NetSuite nghi là khung ({{n}} / {{total}})',
  suggested: 'Gợi ý', acceptN: 'Nhận {{n}} gợi ý', acceptAsk: 'Lưu {{n}} mã vào dòng khung đang chọn?', acceptYes: 'Lưu', cancel: 'Hủy',
  acceptedN: 'Đã lưu {{n}} mã vào dòng khung.', noneLikely: 'Không có mã nào nghi là khung — bỏ tick "Chỉ những mã nghi là khung" để xem phần còn lại.',
  matchesTitle: 'Khách bán hàng được ghép với khách DT ({{y}})', matchesHint: 'Những khách trong dữ liệu bán hàng mà Sheet 2 tính là từng khách DT năm nay — tên chỉ giống phần đầu cũng hiện ở đây.',
  salesCustomer: 'Khách (dữ liệu bán hàng)', noMatches: 'Năm nay chưa có doanh số nào ghép được với khách DT.',
  notFrame: 'Không phải khung', save: 'Lưu', mapSaved: 'Đã lưu {{key}}.', allMapped: 'Mọi mặt hàng có tồn đều đã có dòng khung.',
  buyersHint: 'Các khách HINC bán trực tiếp, theo file doanh số khung. Chỉ xem — thay đổi do Max báo.',
  search: 'Tìm', nOf: '{{n}} / {{total}}', buyer: 'Khách mua', cBefore: 'Trước 2020', c2020: '2020–2025', c2026: 'Từ 2026', country: 'Quốc gia', pricing: 'Chính sách giá',
};
const zh = {
  title: '支架库存月结',
  tab_position: "当前状况",
  allEntities: "全部法人",
  expandAll: "全部展开",
  collapseAll: "全部收起",
  posReading: "正在读取 SAP 和 NetSuite — 约 20 秒…",
  posRefresh: "重新读取",
  posWindow: "自 {{base}} 月末起 · 入库与销售 {{from}} 至 {{to}} · 销售数据至 {{s}}",
  posStock: "库存",
  posOpenPo: "未入库采购订单",
  posCover: "库存月数",
  posEnd: "{{m}} 月末",
  posReceived: "+ 入库",
  posReceivedHint: "此后进入法人自有库存的数量 — 在途货物不计。HINC：1100 工厂收货。",
  posToGroup: "− 转其他法人",
  posToGroupHint: "仅 HINC：此后开票给 HUSA、HEMA、HPAC 的货物（销售组 170）— 离开 HINC 库存但不是客户销售。",
  posSold: "− 销售",
  posOther: "± 其他",
  posOtherHint: "入库和销售无法解释的差额：调整、套装销售、调拨。今日库存为实际读取值，不是推算值。",
  posNow: "= 今日库存",
  posOverdue: "逾期",
  posLater: "之后",
  posNoDate: "无日期",
  posAvg: "月均销售",
  posAvgHint: "截至 {{m}} 的三个月平均",
  posMos: "库存月数",
  posMosHint: "今日库存 ÷ 月均销售。低于 2 会标出。",
  posMosPo: "… 含未入库订单",
  posFamilies: "{{n}} 个系列",
  posGroup: "全部法人",
  posFoot: "HINC 的未入库订单不含其为 HUSA、HEMA、HPAC 货物下的工厂订单（{{n}} 件）：这些法人向 Helinox Inc 的订单已计入。仅含家具和遮阳架 — 帐篷、配件、包不在系列内。",
  posUnmapped: "以下支架型号的销售尚未归入系列：{{list}}",
  sub: '家具支架按月的进销存 — 期初、入库、出库、期末（数量与 KRW）— HINC（成品及单独支架，来自 SAP ZCOR0120）以及 HUSA、HEMA、HPAC（NetSuite 报表 808，按 NetSuite 汇率折算 SGD）。每月约在次月 21 日结账，之后数据保持不变。',
  from: '从', to: '到', refresh: '重新读取', export: '导出 (Excel)', loading: '加载中…',
  tab_summary: '汇总', tab_month: '按系列的月度', tab_sales: '月度销售', tab_loads: '导入与结账', tab_map: '映射', tab_buyers: '直销买家',
  tEndQty: '期末库存 · {{m}}', tEndValue: '期末金额 · {{m}}', vsPrev: '较上月 {{d}}', pcs: '件', krwMil: '百万 KRW',
  tFinished: '成品', tFinishedSub: 'HINC、HUSA、HEMA、HPAC', tPole: '单独支架 (HINC)', tPoleSub: 'SAP 原材料 (ROH)',
  entity: '法人', line: '项目', qty: '数量', krwM: '百万 KRW', closed: '已结账',
  e_HINC: 'HINC（成品）', e_HUSA: 'HUSA', e_HEMA: 'HEMA', e_HPAC: 'HPAC', e_HINC_POLE: 'HINC 单独支架',
  lBegin: '期初库存', lIn: '入库', lOut: '出库', lEnd: '期末库存',
  lBeginNs: '期初库存', lInNs: '入库', lOutNs: '出库', lEndNs: '期末库存',
  lFx: '汇率差异', lGap: '金额差异', lRate: '每 SGD 的 KRW（月末 · 平均）',
  fxHint: 'NetSuite 金额为 SGD：期初按上月末汇率、期末按本月末汇率、入库和出库按月平均汇率折算，剩下的差额就是这一行。',
  gapHint: '入库和出库扣除了开票给销售组 170（内部）的部分，各按其单价计算，因此期初 + 入库 − 出库与期末不完全相等。这一行就是差额。',
  sumFoot: '汇率为读入门户的 NetSuite 每日汇率（以 SGD 为基准）。HINC 为上传的 SAP ZCOR0120；与工作文件一样，描述中含 "(WRT)" 的物料不计入。',
  month: '月份', code: '代码', family: '系列', total: '合计', totalQty: '合计数量', totalKrw: '合计 KRW（百万）', nothingMonth: '本月尚未导入数据。',
  s_begin: '期初', s_in: '入库', s_out: '出库', s_end: '期末',
  year: '年份', product: '产品', salesThrough: '销售截至 {{d}}', portalSays: '门户按当前销售数据算出 {{n}}',
  salesFoot: '工作文件已填写的月份（底色）保留其填写值；之后的月份根据 Sales Report 的表计算 — 支架型号和类别同工作文件的筛选，不含集团内部销售，HINC 拆分为 Montbell + A&F、子渠道 "Others"（ETC）和其余部分。若当前数据算出不同的数，会以删除线显示在填写值下方。',
  loadsHint: '每月需上传 ZCOR0120（SAP）和 NetSuite 库存台账（报表 808），并从 SAP 读取内部开票（销售组 170）。重新导入会替换之前的导入（保留记录）。结账会冻结当月数据；重新打开后可再次导入。',
  otherMonth: '其他月份', srcSap: 'SAP ZCOR0120', srcNs: 'NetSuite 台账 (808)', srcInternal: '内部开票（组 170）', status: '状态', action: '操作',
  rows: '行', notLoaded: '未导入', lastFailed: '上次导入失败', running: '运行中…', upload: '上传文件', readSap: '从 SAP 读取',
  closedBy: '{{by}} 结账 · {{when}}', open: '未结账', reopen: '重新打开', close: '月结', closeNeeds: '请先导入 ZCOR0120 或 NetSuite 台账。',
  rowsRead: '已读取 {{n}} 行', reopened: '{{m}} 已重新打开。', closedOk: '{{m}} 已结账 — 保存 {{n}} 项数据。',
  mapCounts: '{{fam}} 个系列 · {{sap}} 个 SAP 物料 · {{ns}} 个 NetSuite 品项已映射', mapHint: '本月导入数据中有库存或收发但未映射到任何系列的项目。在此归入系列后，从下次计算起生效（已结账的月份保持原数）。',
  unSap: '无系列的 SAP 物料（{{n}}）', unNs: '无系列的 NetSuite 品项（{{n}}）', material: '物料', description: '描述', type: '类型', endQty: '期末数量', parent: '品项（上级）', lines: '行数',
  sheet1: '表 1 · 按法人', sheet2: '表 2 · 拆出 DT', typedThrough: '至 {{m}} 沿用已填写值',
  salesFoot2: '表 2 将各法人卖给直销（DT）名单上客户的数量从该法人行中移出，计入 "<法人> DT" 行 — 按实际销售的法人计算。匹配到的客户列在直销客户页签。',
  why_same: 'KS 映射中同名', why_mapped: '包含已映射名称 "{{term}}"', why_family: '包含系列名称 "{{term}}"',
  onlyLikely: '只看疑似支架', unSapLikely: '疑似支架的 SAP 物料（{{n}} / {{total}}）', unNsLikely: '疑似支架的 NetSuite 品项（{{n}} / {{total}}）',
  suggested: '建议', acceptN: '采纳 {{n}} 条建议', acceptAsk: '将 {{n}} 个项目保存到所选系列？', acceptYes: '保存', cancel: '取消',
  acceptedN: '已将 {{n}} 个项目保存到系列。', noneLikely: '没有疑似支架的项目 — 取消勾选"只看疑似支架"可查看其余项目。',
  matchesTitle: '匹配到 DT 客户的销售客户（{{y}}）', matchesHint: '今年表 2 计为各 DT 客户的销售客户 — 名称仅开头相同的也会列出。',
  salesCustomer: '销售客户', noMatches: '今年没有销售匹配到 DT 客户。',
  notFrame: '不是支架', save: '保存', mapSaved: '{{key}} 已保存。', allMapped: '所有有库存的项目都已映射到系列。',
  buyersHint: 'HINC 直接销售的买家（按支架销售文件）。仅供查看 — 变更由 Max 通知。',
  search: '搜索', nOf: '{{total}} 中的 {{n}}', buyer: '买家', cBefore: '2020 年以前', c2020: '2020–2025', c2026: '2026 年起', country: '国家', pricing: '定价',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "title": "Clôture du stock d'arceaux",
  "tab_position": "Position actuelle",
  "allEntities": "Toutes les entités",
  "expandAll": "Tout développer",
  "collapseAll": "Tout réduire",
  "posReading": "Lecture de SAP et NetSuite — environ 20 secondes…",
  "posRefresh": "Relire",
  "posWindow": "Depuis la fin de {{base}} · reçu et vendu du {{from}} au {{to}} · ventes jusqu'au {{s}}",
  "posStock": "Stock",
  "posOpenPo": "Commandes d'achat ouvertes (pas encore reçues)",
  "posCover": "Couverture",
  "posEnd": "Fin {{m}}",
  "posReceived": "+ Reçu",
  "posReceivedHint": "Marchandises reçues dans le stock propre de l'entité depuis lors — les marchandises en transit ne sont pas comptées. HINC : entrées de marchandises à l'usine 1100.",
  "posToGroup": "− Vers d'autres entités",
  "posToGroupHint": "HINC uniquement : marchandises refacturées à HUSA, HEMA et HPAC (groupe de vente 170) depuis lors — elles quittent le stock de HINC mais ne sont pas des ventes clients.",
  "posSold": "− Vendu",
  "posOther": "± Autre",
  "posOtherHint": "Ce que reçu et vendu n'expliquent pas : ajustements, sets vendus comme un seul article, transferts. Le stock d'aujourd'hui est lu, pas calculé.",
  "posNow": "= Stock aujourd'hui",
  "posOverdue": "En retard",
  "posLater": "Plus tard",
  "posNoDate": "Sans date",
  "posAvg": "Ventes moy. / mois",
  "posAvgHint": "Le mois moyen des trois mois jusqu'à {{m}}",
  "posMos": "Mois de stock",
  "posMosHint": "Stock aujourd'hui ÷ ventes mensuelles moyennes. Moins de 2 est signalé.",
  "posMosPo": "… PO ouverts inclus",
  "posFamilies": "{{n}} familles",
  "posGroup": "Toutes les entités",
  "posFoot": "Les PO ouverts de HINC excluent les commandes d'usine qu'elle passe pour les produits de HUSA, HEMA et HPAC ({{n}} pcs) : les PO propres de ces entités auprès de Helinox Inc les comptent déjà. Cadres de mobilier et d'ombrage uniquement — les tentes, accessoires et sacs ne figurent pas dans les familles.",
  "posUnmapped": "Les ventes de ces modèles de cadres ne sont encore dans aucune famille : {{list}}",
  "sub": "Le mouvement de stock des cadres de mobilier mois par mois — Début, Entrées, Sorties, Fin, en pièces et en KRW — pour HINC (produits finis et cadres uniquement, depuis SAP ZCOR0120) et HUSA, HEMA, HPAC (rapport NetSuite 808, SGD aux taux propres de NetSuite). Un mois est clôturé vers le 21 du mois suivant et ses chiffres sont alors figés.",
  "from": "Du",
  "to": "Au",
  "refresh": "Relire",
  "export": "Exporter (Excel)",
  "loading": "Chargement…",
  "tab_summary": "Synthèse",
  "tab_month": "Mois par famille",
  "tab_sales": "Ventes mensuelles",
  "tab_loads": "Chargements et clôture",
  "tab_map": "Mapping",
  "tab_buyers": "Acheteurs en vente directe",
  "tEndQty": "Stock final · {{m}}",
  "tEndValue": "Valeur finale · {{m}}",
  "vsPrev": "{{d}} par rapport au mois précédent",
  "pcs": "pcs",
  "krwMil": "millions de KRW",
  "tFinished": "Produits finis",
  "tFinishedSub": "HINC, HUSA, HEMA, HPAC",
  "tPole": "Cadres uniquement (HINC)",
  "tPoleSub": "Matière première SAP (ROH)",
  "entity": "Entité",
  "line": "Ligne",
  "qty": "Qté",
  "krwM": "M KRW",
  "closed": "clôturé",
  "e_HINC": "HINC (Complete)",
  "e_HUSA": "HUSA",
  "e_HEMA": "HEMA",
  "e_HPAC": "HPAC",
  "e_HINC_POLE": "HINC arceaux uniquement",
  "lBegin": "Stock initial",
  "lIn": "Stock reçu",
  "lOut": "Stock sorti",
  "lEnd": "Stock final",
  "lBeginNs": "Stock initial",
  "lInNs": "Entrées de stock",
  "lOutNs": "Sorties de stock",
  "lEndNs": "Stock final",
  "lFx": "Écart de change",
  "lGap": "Écart de valeur",
  "lRate": "KRW par SGD (fin de mois · moyenne)",
  "fxHint": "Les valeurs NetSuite sont en SGD : Début au taux de fin du mois précédent, Fin au taux de fin de ce mois, Entrées et Sorties au taux moyen du mois. Ce qui reste est cette ligne.",
  "gapHint": "Reçu et Sorti excluent ce qui a été facturé au groupe de vente 170 (interne), chacun à son propre coût unitaire, si bien que Début + Entrées − Sorties n'atteint pas tout à fait Fin. Cette ligne est la différence.",
  "sumFoot": "Les taux sont les taux quotidiens propres de NetSuite (base SGD), lus dans le portail. HINC provient de SAP ZCOR0120 tel qu'importé ; les matériaux dont la description contient « (WRT) » sont exclus, comme dans le fichier de travail.",
  "month": "Mois",
  "code": "Code",
  "family": "Famille",
  "total": "Total",
  "totalQty": "Qté totale",
  "totalKrw": "Total KRW (millions)",
  "nothingMonth": "Rien n'est chargé pour ce mois.",
  "s_begin": "Début",
  "s_in": "Entrées",
  "s_out": "Sorties",
  "s_end": "Fin",
  "year": "Année",
  "product": "Produit",
  "salesThrough": "Ventes jusqu'au {{d}}",
  "portalSays": "Le portail calcule {{n}} à partir des données de vente d'aujourd'hui",
  "salesFoot": "Un mois saisi dans le fichier de travail (grisé) conserve son chiffre saisi ; les mois suivants sont calculés à partir du propre tableau du Sales Report — modèles de cadres et catégories selon le filtre du fichier de travail, ventes entre sociétés internes exclues, HINC réparti en Montbell + A&F, le sous-canal « Others » (ETC) et le reste. Lorsque les données d'aujourd'hui donnent un autre chiffre, il apparaît barré sous le chiffre saisi.",
  "loadsHint": "Chaque mois nécessite l'import de ZCOR0120 (SAP) et du grand livre de stock NetSuite (rapport 808), et la lecture de la facturation interne (groupe de vente 170) depuis SAP. Un nouveau chargement remplace le précédent (conservé). Clôturer fige les chiffres du mois ; Rouvrir permet de le recharger.",
  "otherMonth": "Autre mois",
  "srcSap": "SAP ZCOR0120",
  "srcNs": "Grand livre NetSuite (808)",
  "srcInternal": "Facturation interne (groupe 170)",
  "status": "Statut",
  "action": "Action",
  "rows": "lignes",
  "notLoaded": "Non chargé",
  "lastFailed": "Dernier chargement en échec",
  "running": "En cours…",
  "upload": "Importer un fichier",
  "readSap": "Lire depuis SAP",
  "closedBy": "Clôturé par {{by}} · {{when}}",
  "open": "Ouvert",
  "reopen": "Rouvrir",
  "close": "Clôturer le mois",
  "closeNeeds": "Chargez d'abord ZCOR0120 ou le grand livre NetSuite.",
  "rowsRead": "{{n}} lignes lues",
  "reopened": "{{m}} est de nouveau ouvert.",
  "closedOk": "{{m}} clôturé — {{n}} chiffres conservés.",
  "mapCounts": "{{fam}} familles · {{sap}} matériaux SAP · {{ns}} articles NetSuite mappés",
  "mapHint": "Ce que les chargements de ce mois contiennent comme stock ou mouvement sans correspondance avec une famille. Un matériau ou un article placé dans une famille ici est pris en compte au prochain calcul des chiffres (un mois clôturé conserve ses chiffres).",
  "unSap": "Matériaux SAP sans famille ({{n}})",
  "unNs": "Articles NetSuite sans famille ({{n}})",
  "material": "Matériau",
  "description": "Description",
  "type": "Type",
  "endQty": "Qté finale",
  "parent": "Article (parent)",
  "lines": "Lignes",
  "sheet1": "Feuille 1 · par entité",
  "sheet2": "Feuille 2 · DT séparé",
  "typedThrough": "historique saisi jusqu'à {{m}}",
  "salesFoot2": "La feuille 2 retire les ventes de chaque entité à un acheteur de la liste des ventes directes (DT) de la ligne de l'entité pour les placer dans « <entity> DT » — c'est l'entité qui a réalisé la vente qui est comptée. Les clients correspondants sont listés dans l'onglet Acheteurs en vente directe.",
  "why_same": "même nom dans le mapping KS",
  "why_mapped": "contient le nom mappé « {{term}} »",
  "why_family": "contient le nom de famille « {{term}} »",
  "onlyLikely": "Cadres probables uniquement",
  "unSapLikely": "Matériaux SAP qui ressemblent à un cadre ({{n}} sur {{total}})",
  "unNsLikely": "Articles NetSuite qui ressemblent à un cadre ({{n}} sur {{total}})",
  "suggested": "Suggéré",
  "acceptN": "Accepter {{n}} suggestions",
  "acceptAsk": "Enregistrer {{n}} articles dans la famille indiquée dans leur case ?",
  "acceptYes": "Enregistrer",
  "cancel": "Annuler",
  "acceptedN": "{{n}} articles enregistrés dans leurs familles.",
  "noneLikely": "Rien ici ne ressemble à un cadre — décochez « Cadres probables uniquement » pour voir le reste.",
  "matchesTitle": "Clients de vente rattachés à un acheteur DT ({{y}})",
  "matchesHint": "Les clients de vente que la feuille 2 a comptés comme chaque acheteur cette année — un nom qui commence seulement comme celui d'un acheteur apparaît ici.",
  "salesCustomer": "Client de vente",
  "noMatches": "Aucune vente rattachée à un acheteur DT cette année.",
  "notFrame": "Pas un cadre",
  "save": "Enregistrer",
  "mapSaved": "{{key}} enregistré.",
  "allMapped": "Tout ce qui a du stock correspond à une famille.",
  "buyersHint": "Les acheteurs auxquels HINC vend directement, tels que les liste le fichier des ventes de cadres. Affichage seul — les modifications viennent de Max.",
  "search": "Rechercher",
  "nOf": "{{n}} sur {{total}}",
  "buyer": "Acheteur",
  "cBefore": "Avant 2020",
  "c2020": "2020–2025",
  "c2026": "À partir de 2026",
  "country": "Pays",
  "pricing": "Tarification"
};
const ja = {
  "title": "ポール在庫の締め",
  "tab_position": "現在のポジション",
  "allEntities": "すべてのエンティティ",
  "expandAll": "すべて展開",
  "collapseAll": "すべて折りたたむ",
  "posReading": "SAP と NetSuite を読み込み中 — 約20秒…",
  "posRefresh": "再読み込み",
  "posWindow": "{{base}} 末から · 入荷と販売 {{from}} ～ {{to}} · 販売は {{s}} まで",
  "posStock": "在庫",
  "posOpenPo": "未入荷の発注（PO）",
  "posCover": "カバー",
  "posEnd": "{{m}} 末",
  "posReceived": "+ 入荷",
  "posReceivedHint": "その後にエンティティ自身の在庫へ入荷した商品です — 輸送中の商品は含みません。HINC：プラント 1100 の入庫。",
  "posToGroup": "− 他エンティティへ",
  "posToGroupHint": "HINC のみ：その後に HUSA、HEMA、HPAC へ請求した商品（販売グループ 170）です — HINC の在庫からは出ますが、顧客への販売ではありません。",
  "posSold": "− 販売",
  "posOther": "± その他",
  "posOtherHint": "入荷と販売で説明できない分：調整、セット商品の1点販売、移動など。本日の在庫は計算ではなく読み取った値です。",
  "posNow": "= 本日の在庫",
  "posOverdue": "期日超過",
  "posLater": "それ以降",
  "posNoDate": "日付なし",
  "posAvg": "月平均販売",
  "posAvgHint": "{{m}} までの3か月の月平均",
  "posMos": "在庫月数",
  "posMosHint": "本日の在庫 ÷ 月平均販売。2 未満は強調表示されます。",
  "posMosPo": "… 未入荷 PO を含む",
  "posFamilies": "{{n}} ファミリー",
  "posGroup": "すべてのエンティティ",
  "posFoot": "HINC の未入荷 PO には、HUSA、HEMA、HPAC 向け商品のために HINC が出す工場発注（{{n}} pcs）は含まれません。これらのエンティティが Helinox Inc に出す自社 PO にすでに含まれているためです。家具用とシェード用のフレームのみで、テント、アクセサリー、バッグはファミリーに含まれません。",
  "posUnmapped": "これらのフレームモデルの販売は、まだどのファミリーにも属していません：{{list}}",
  "sub": "家具用フレームの在庫増減を月ごとに表示します — 期首、入庫、出庫、期末を数量（pcs）と KRW で。HINC（完成品とフレームのみ、SAP ZCOR0120 より）と HUSA、HEMA、HPAC（NetSuite レポート 808、SGD は NetSuite 自身のレート）が対象です。月は翌月21日頃に締められ、その後は数値が当時のまま保持されます。",
  "from": "開始",
  "to": "終了",
  "refresh": "再読み込み",
  "export": "エクスポート（Excel）",
  "loading": "読み込み中…",
  "tab_summary": "サマリー",
  "tab_month": "ファミリー別月次",
  "tab_sales": "月次販売",
  "tab_loads": "読み込みと締め",
  "tab_map": "マッピング",
  "tab_buyers": "直販バイヤー",
  "tEndQty": "期末在庫 · {{m}}",
  "tEndValue": "期末金額 · {{m}}",
  "vsPrev": "前月比 {{d}}",
  "pcs": "pcs",
  "krwMil": "KRW 百万",
  "tFinished": "完成品",
  "tFinishedSub": "HINC、HUSA、HEMA、HPAC",
  "tPole": "フレームのみ（HINC）",
  "tPoleSub": "SAP 原材料（ROH）",
  "entity": "エンティティ",
  "line": "ライン",
  "qty": "数量",
  "krwM": "KRW 百万",
  "closed": "締め済み",
  "e_HINC": "HINC (Complete)",
  "e_HUSA": "HUSA",
  "e_HEMA": "HEMA",
  "e_HPAC": "HPAC",
  "e_HINC_POLE": "HINC ポールのみ",
  "lBegin": "期首在庫",
  "lIn": "入庫",
  "lOut": "出庫",
  "lEnd": "期末在庫",
  "lBeginNs": "期首在庫",
  "lInNs": "入庫",
  "lOutNs": "出庫",
  "lEndNs": "期末在庫",
  "lFx": "為替差額",
  "lGap": "金額差異",
  "lRate": "SGD あたり KRW（月末 · 平均）",
  "fxHint": "NetSuite の金額は SGD です。期首は前月末レート、期末は当月末レート、入庫と出庫は当月の平均レートで換算します。その差がこの行です。",
  "gapHint": "入荷と出庫には、販売グループ 170（社内）に請求した分が含まれておらず、それぞれ個別の単価で計上されるため、期首 + 入庫 − 出庫 は期末とぴったり一致しません。この行がその差額です。",
  "sumFoot": "レートは NetSuite 自身の日次レート（SGD 基準）をポータルに取り込んだものです。HINC はアップロードされた SAP ZCOR0120 で、品名に「(WRT)」を含む品目は作業用ファイルと同様に除外しています。",
  "month": "月",
  "code": "コード",
  "family": "ファミリー",
  "total": "合計",
  "totalQty": "合計数量",
  "totalKrw": "KRW 合計（百万）",
  "nothingMonth": "この月に読み込まれたデータはありません。",
  "s_begin": "期首",
  "s_in": "入庫",
  "s_out": "出庫",
  "s_end": "期末",
  "year": "年",
  "product": "製品",
  "salesThrough": "{{d}} までの販売",
  "portalSays": "ポータルは本日の販売データから {{n}} を算出しています",
  "salesFoot": "作業用ファイルで手入力された月（網掛け）は入力値を保持します。それ以降の月は Sales Report 自身のテーブルから算出します — フレームモデルとカテゴリは作業用ファイルのフィルターに準拠し、社内会社間の販売は除外、HINC は Montbell + A&F、サブチャネル「Others」（ETC）、その他に分割します。本日のデータが別の値を示す場合は、入力値の下に取り消し線付きで表示されます。",
  "loadsHint": "各月に、ZCOR0120（SAP）と NetSuite 在庫台帳（レポート 808）のアップロード、および SAP からの社内請求（販売グループ 170）の読み取りが必要です。再度読み込むと前回の読み込みを置き換えます（履歴は保持）。「締め」で当月の数値が固定され、「再開」で再読み込みができるようになります。",
  "otherMonth": "別の月",
  "srcSap": "SAP ZCOR0120",
  "srcNs": "NetSuite 台帳（808）",
  "srcInternal": "社内請求（グループ 170）",
  "status": "ステータス",
  "action": "操作",
  "rows": "行",
  "notLoaded": "未読み込み",
  "lastFailed": "前回の読み込みに失敗",
  "running": "実行中…",
  "upload": "ファイルをアップロード",
  "readSap": "SAP から読み込み",
  "closedBy": "{{by}} が締め · {{when}}",
  "open": "オープン",
  "reopen": "再開",
  "close": "月を締める",
  "closeNeeds": "先に ZCOR0120 または NetSuite 台帳を読み込んでください。",
  "rowsRead": "{{n}} 行を読み込みました",
  "reopened": "{{m}} を再開しました。",
  "closedOk": "{{m}} を締めました — {{n}} 件の数値を保持。",
  "mapCounts": "{{fam}} ファミリー · SAP 品目 {{sap}} 件 · NetSuite アイテム {{ns}} 件をマッピング済み",
  "mapHint": "当月の読み込みに含まれる在庫または動きがあるもので、どのファミリーにもマッピングされていないものです。ここでファミリーに割り当てた品目やアイテムは、次回の数値算出から反映されます（締め済みの月は数値が保持されます）。",
  "unSap": "ファミリー未設定の SAP 品目（{{n}}）",
  "unNs": "ファミリー未設定の NetSuite アイテム（{{n}}）",
  "material": "品目",
  "description": "品名",
  "type": "タイプ",
  "endQty": "期末数量",
  "parent": "アイテム（親）",
  "lines": "行数",
  "sheet1": "シート 1 · エンティティ別",
  "sheet2": "シート 2 · DT 分離",
  "typedThrough": "{{m}} までの手入力履歴",
  "salesFoot2": "シート 2 は、直販（DT）リストのバイヤーへの各エンティティの販売を、そのエンティティの行から「<entity> DT」へ移します — 計上されるのは販売を行ったエンティティです。一致した顧客は「直販バイヤー」タブに一覧表示されます。",
  "why_same": "KS マップに同じ名称あり",
  "why_mapped": "マッピング済みの名称「{{term}}」を含む",
  "why_family": "ファミリー名「{{term}}」を含む",
  "onlyLikely": "フレームの可能性が高いもののみ",
  "unSapLikely": "フレームらしい SAP 品目（{{total}} 件中 {{n}} 件）",
  "unNsLikely": "フレームらしい NetSuite アイテム（{{total}} 件中 {{n}} 件）",
  "suggested": "推奨",
  "acceptN": "{{n}} 件の推奨を承認",
  "acceptAsk": "{{n}} 件のアイテムを、それぞれのボックスのファミリーに保存しますか？",
  "acceptYes": "保存",
  "cancel": "キャンセル",
  "acceptedN": "{{n}} 件のアイテムをそれぞれのファミリーに保存しました。",
  "noneLikely": "フレームらしいものはありません — 「フレームの可能性が高いもののみ」のチェックを外すと残りが表示されます。",
  "matchesTitle": "DT バイヤーに一致した販売先顧客（{{y}}）",
  "matchesHint": "今年、シート 2 が各バイヤーとして集計した販売先顧客です — バイヤー名と先頭だけが似ている名称もここに表示されます。",
  "salesCustomer": "販売先顧客",
  "noMatches": "今年、DT バイヤーに一致した販売はありません。",
  "notFrame": "フレームではない",
  "save": "保存",
  "mapSaved": "{{key}} を保存しました。",
  "allMapped": "在庫のあるものはすべてファミリーにマッピングされています。",
  "buyersHint": "フレーム販売ファイルに記載されている、HINC が直接販売しているバイヤーです。表示のみで、変更は Max が行います。",
  "search": "検索",
  "nOf": "{{total}} 件中 {{n}} 件",
  "buyer": "バイヤー",
  "cBefore": "2020年以前",
  "c2020": "2020–2025",
  "c2026": "2026年以降",
  "country": "国",
  "pricing": "価格設定"
};

export default { ns: 'xPole', en, ko, vi, zh, fr, ja };
